import React, { useContext, useEffect, useRef, useState } from "react";
import {Autocomplete,TextField, FormControl, FormControlLabel, Stack, Button, Card, RadioGroup, Radio, Container, FormGroup, IconButton, InputAdornment, Modal, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForeverRounded';
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import dayjs from 'dayjs';
import config from '../../../hoa-config';
import { getFileExtension, sortViolations } from '../../../utility/helper';
import { getNegativeValueInAccountingForm } from '../../../utility/format-display-output';
import CustomDateField from "../../../Container/custom-date-field";
import dashboardServices from "../../../services/hoa-dashboard-api-service";
import { GlobalContext } from '../../../context/hoa-global-context';
import hoaDatastore from "../../../store/hoa-datastore";
import SourceIdVerificationComp from "./common/SourceIdVerificationComp";
import { useSelectedTaskStoreStore } from '../../../store/useTaskStore';

const ReportedViolationModal = ({
    propertyData,
	open,
	handleClose,
    updateIndex,
    setUpdateIndex,
    violation,
    setViolation,
    violationError,
    setViolationError,
    violationList,
    setViolationLists,
    parentViolationBeforeAddingNewStage,
    setParentViolationBeforeAddingNewStage
}: any) => {
    const [error, setError] = useState(false);
	const [files, setFiles] = useState([]);
    const [sourceIdStatus, setSourceIdStatus] = useState(null);
    const [loading, setLoading] = useState(false);
    const [emailFilesOptions, setEmailFilesOptions] = useState([]);
    const [selectedFileFromEmail, setSelectedFileFromEmail] = useState([]);
    const [selectedFileFromMail, setSelectedFileFromMail] = useState(null);
    const [renamedFiles, setRenamedFiles] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isSavingConfirmationModalOpen, setIsSavingConfirmationModalOpen] = useState(false);
    const [documentIndex, setDocumentIndex] = useState(null);
    const { property, activeMenu } = useContext<any>(GlobalContext);
    const { findDataMatchWithSelectedValue } = useSelectedTaskStoreStore()

    useEffect(() => {
		if (activeMenu === 'propertiespendingtask' && open === true && !violation.objectId) {
            const selectedProperty = hoaDatastore.getIdFromUrl();
			const propertyValue = findDataMatchWithSelectedValue(property.data, hoaDatastore);
            if(!propertyValue) return;
            if(propertyValue?.taskSourceType === 'mail') {
                const propertyConnectedWithMail = propertyValue?.mailDetails?.propertyList || [];
                const isPropertyIncluded = propertyConnectedWithMail.find(
                    (property: any) => property.objectId === selectedProperty
                );
                if (isPropertyIncluded) {
                    setSourceIdStatus("verified");
                    setViolation({
                        ...violation,
                        sourceIdType: "mail",
                        sourceId: propertyValue?.mailDetails?.id || "",
                        newViolationFileToUpload: [propertyValue?.mailDetails?.attachmentDetails?.name],
                    });
                }
            } else if (propertyValue?.taskSourceType === 'email') {
                const propertyConnectedWithMail = propertyValue?.emailDetails?.propertyList || [];
                const isPropertyIncluded = propertyConnectedWithMail.find(
                    (property: any) => property.objectId === selectedProperty
                );
                if (isPropertyIncluded) {
                    setSourceIdStatus("verified");
                    setViolation({
                        ...violation,
                        sourceIdType: "email",
                        sourceId: propertyValue?.emailDetails?.id || "",
                        newViolationFileToUpload: propertyValue?.emailDetails?.attachmentDetails ||[],
                    });
                }
            }
			return;
		}
    },[open])

	const onClose = () => {
        setError(false);
        setFiles([]);
		handleClose();
        setSourceIdStatus(null);
	};

    const onClickStageModalClose = () => {
        if (parentViolationBeforeAddingNewStage) {
            setViolation(parentViolationBeforeAddingNewStage);
        }

        setSelectedFileFromMail(null);
        setSelectedFileFromEmail([]);
        setFiles([]);
        handleClose();
        setUpdateIndex(null);
    }

    useEffect(() => {
        if(activeMenu === 'propertiespendingtask' && !violation?.objectId) return;

        if (sourceIdStatus === "verified") {
            setSourceIdStatus("");
        }
    }, [violation.sourceIdType, violation.sourceId]);

    useEffect(() => {
        if (updateIndex >= 0) {
            setSourceIdStatus('verified');
        }
    }, [updateIndex]);

    useEffect(() => {
        setSelectedFileFromMail(null);
        setSelectedFileFromEmail([]);
        setEmailFilesOptions([]);
    }, [violation.sourceIdType])

    useEffect(() => {
        if (open) {
            if(violation.violationNoticeFiles){
                setFiles(violation.violationNoticeFiles)
            }
            if(violation?.renamedFiles) {
                setRenamedFiles(violation.renamedFiles);
            }
            if(violation?.newViolationFileToUpload && violation.sourceId && violation.sourceIdType == 'mail'){ 
                setSelectedFileFromMail(violation.newViolationFileToUpload);
            }
            if(violation?.newViolationFileToUpload && violation.sourceId && violation.sourceIdType == 'email'){ 
                setSelectedFileFromEmail(violation.newViolationFileToUpload);
                setEmailFilesOptions(violation.newViolationFileToUpload);
            }
            if(!violation.hoaInfo){
                violation['hoaInfo'] = [
                    {
                        hoaName: '',
                        hoaId: ''
                    }
                ]
            }
            if(!violation.violationType && !violation.createdAt) { 
                violation['violationType'] = 'HOA Violation'
            }
        }
    }, [violation, open]);

    const Wheel =(e: any) => {
        e.target.blur();
    }

    const handleChange = (event: any) => {
    let updatedViolation: any;

    if (event?.date) {
        updatedViolation = {
            ...violation,
            [event.date.key]: event.date.value,
        };
    } else if (event?.check) {
        updatedViolation = {
            ...violation,
            [event.check.key]: event.check.value,
        };
    } else {
        updatedViolation = {
            ...violation,
            [event.target.name]: event.target.value,
        };
    }

    // Special case: If violationType is being set to "HOA Violation"
    const newViolationType =
        event?.target?.name === 'violationType'
            ? event.target.value
            : updatedViolation.violationType;

    if (newViolationType === 'HOA Violation') {
        const { otherEntityInformation, ...rest } = updatedViolation;
        updatedViolation = rest;
    }

    setViolation(updatedViolation);
    };


    const handleOtherEntityChange = (event:any) => {
        setViolation({
            ...violation,
            otherEntityInformation: {
                ...violation.otherEntityInformation,
                [event.target.name]: event.target.value
            }
        })
    }

    const deleteModalOpen = (idx: number) => {
        setIsOpen(true);
        setDocumentIndex(idx);
    }

    const handleDeleteModalClose = () => {
        setIsOpen(false);
    }

    const documentDelete = () => {
        const updatedFiles = files.filter((file: any, index: number) => index != documentIndex);
        
        const violationCopy = JSON.parse(JSON.stringify(violation));
        violationCopy.violationNoticeFiles = updatedFiles;

        if (updatedFiles.length == 0) {
            setSourceIdStatus('');
        }
        setViolation(violationCopy);

        handleDeleteModalClose();
    }

    const isDuplicateFound = () => {
        if (violation.noticeDate && violation.violationCategory) {
            for (const item of violationList) {
                if ((updateIndex == null || updateIndex < 0) && item.noticeDate && new Date(violation.noticeDate).toISOString() == new Date(item.noticeDate).toISOString() && violation.violationCategory == item.violationCategory) {
                    return true;
                }
            }
        }

        return false;
    }

    const saveClickBtnClicked = () => {
        if (isDuplicateFound()) {
            setIsSavingConfirmationModalOpen(true);    
        }
        else {
            onSaveClick();
        }
    }

    const continueBtnClicked = () => {
        setIsSavingConfirmationModalOpen(false);
        onSaveClick();
    }

    const onSaveClick = () => {
        if(!violation.violation || !violation.violationFee || !violation.sourceId || !violation.violationCategory || !violation.violationSubcategory || !violation.stage || !violation.noticeDate){
            setError(true);
            return;
        }

        if(violation?.violationType === "City Violation" && (!violation?.otherEntityInformation?.name || !violation?.otherEntityInformation?.email || !violation?.otherEntityInformation?.phone || !violation?.otherEntityInformation?.address)) {
            setError(true);
            return;
        }

        if (!violation.hoaInfo || 
            violation.hoaInfo.length === 0 || 
            violation.hoaInfo.some((info: any) => info.hoaId === '' || info.hoaName === '')) {
            setError(true);
            return;
        }

        if(files.length <=0 && selectedFileFromEmail?.length <= 0 && (!selectedFileFromMail || selectedFileFromMail?.length <= 0)) {
            setError(true);
            return;
        }
        setError(false);
        let violationCopy = JSON.parse(JSON.stringify(violation));
        
        violationCopy.newViolationFileToUpload = violation.sourceIdType == 'mail' ? selectedFileFromMail : violation.sourceIdType == 'email' ? selectedFileFromEmail : null;

        let violationListCopy = violationList;
        violationCopy.isDeleted = false;
        if(violationCopy.noticeStatus === undefined){
            violationCopy.noticeStatus = 'active'
        }

        let objectIdForRenamedFile = violation.objectId;

        if ((updateIndex == null || updateIndex < 0) && parentViolationBeforeAddingNewStage) {
            objectIdForRenamedFile = null;
        }


        if(Array.isArray(violationCopy.newViolationFileToUpload) && violationCopy.newViolationFileToUpload.length > 0) {
            const renamedFilesWithFees:any = [];
            
            for (const fileName of violationCopy.newViolationFileToUpload) {
                const fileExtension = getFileExtension(fileName);
                const valueInAccountingForm = getNegativeValueInAccountingForm(violation?.violationFee);
                const newFileName = `${valueInAccountingForm}-${violation.stage}${objectIdForRenamedFile ? `-${objectIdForRenamedFile}` : ''}-${violation.violationSubcategory}.${fileExtension}`;    

                renamedFilesWithFees.push(newFileName);
            }
                            
            violationCopy.newRenamedViolationFileToUpload = renamedFilesWithFees;
        }

        
        if(updateIndex != null && updateIndex > -1){
            violationCopy.violationDetailsUpdatedAt = new Date();
            violationListCopy = violationList.map((item: any, index: number) => index === updateIndex ? violationCopy : item)
            setViolationLists(violationListCopy);
            if (parentViolationBeforeAddingNewStage) {
                if (parentViolationBeforeAddingNewStage.objectId === violationCopy.objectId) {
                    setViolation(violationCopy);
                }
                else {
                    setViolation(parentViolationBeforeAddingNewStage);    
                }
            }
            onClose();
            setUpdateIndex(null);
        } else {
            // insert new stage and update child list
            if (parentViolationBeforeAddingNewStage) {
                const newChildViolationIdsList:any = [];
                newChildViolationIdsList.push(parentViolationBeforeAddingNewStage.objectId);
                if (Array.isArray(parentViolationBeforeAddingNewStage.childViolationIdsList)) {
                    parentViolationBeforeAddingNewStage.childViolationIdsList.forEach((item:any) => {
                        newChildViolationIdsList.push(item);
                    })
                }

                violationCopy.childViolationIdsList = newChildViolationIdsList;
                violationCopy.objectId = null;

                for (const item of violationListCopy) {
                    if (item.objectId === parentViolationBeforeAddingNewStage.objectId) {
                        item.latestViolationStage = violationCopy.stage;
                        item.childViolationIdsList = [];
                    }
                }
            }

            setViolationLists([violationCopy, ...violationListCopy]);
            onClose();

            if (parentViolationBeforeAddingNewStage) {
                setViolation(violationCopy);
            }
            else {
                setViolation({});
            }
        }
    }

    const addNewHoaInfo = () => {
        const tempViolation = {...violation};
        const newHoaInfo = {
            hoaName: '',
            hoaId: ''
        };
        tempViolation['hoaInfo'].push(newHoaInfo);
        setViolation(tempViolation);
    }

    const removeHoaInfo = (index: number) => {
        let tempViolation = {...violation};
        tempViolation.hoaInfo = tempViolation.hoaInfo.filter((each: any, idx: number) => idx !== index);
        setViolation(tempViolation);
    }

    const handleHoaInfo = (index: number, key: string, value: string) => {
        const tempViolation = {...violation};
        tempViolation.hoaInfo[index] = {
            ...tempViolation.hoaInfo[index],
            [key]: value
        }
        setViolation(tempViolation)
    }

    const clearSelectedStage = () => {
        let violationCopy = JSON.parse(JSON.stringify(violation));
        violationCopy.stage = '';
        setViolation(violationCopy);
    }
    
    const handleDropdown = (value: string, key: string) => {
        if(key === 'violationCategory'){
            setViolation({
                ...violation,
                violationSubcategory: null,
                [key]: value,
            })
        }else{
            setViolation({
                ...violation,
                [key]: value,
            })
        }
    }

    const setUploadedFiles = (fileItems:any) => {
        const violationCopy = JSON.parse(JSON.stringify(violation));
        violationCopy.violationNoticeFiles = [...files, ...fileItems];
        violationCopy.renamedFiles = [...renamedFiles, ...fileItems];
        
        setViolation(violationCopy);
    }

    const getFilesBySourceId = async () => {
        if (violation.sourceId && violation.sourceIdType && propertyData.objectId) {
            setLoading(true);
            const result:any = await dashboardServices.getFilesBySourceId(violation.sourceId, violation.sourceIdType, propertyData.objectId);
            setLoading(false);

            if (Array.isArray(result?.data) && result.data.length > 0) {
                if (violation.sourceIdType === 'mail' && Array.isArray(result.data) && result.data.length > 0) {
                    setSourceIdStatus("verified");
                    setSelectedFileFromMail(result.data);
                }
                else if (violation.sourceIdType === 'email') {
                    setSourceIdStatus('');
                    setEmailFilesOptions(result.data);
                }
            }
            else {
                if (violation.sourceIdType === 'email') {
                    setEmailFilesOptions([]);
                }
                setSourceIdStatus("error");
            }
        }
    }

    const handleSelectFileFromEmail = (event:any) => {
        const {
            target: { value },
        } = event;

        if (value.length > 0) {
            setSourceIdStatus('verified');
        }
        else {
            setSourceIdStatus('');
        }

        typeof value === 'string' ? value.split(',') : value,

        setSelectedFileFromEmail(value);
    }

    const isSourceIdTypeDisabled = () => {
        return files?.length > 0 || selectedFileFromEmail?.length > 0 || selectedFileFromMail;
    }

    const isVerifyDisabled = () => {
        return (selectedFileFromEmail?.length > 0 || selectedFileFromMail || !violation.sourceId || !violation.sourceIdType
            || files?.length > 0
        );
    }

    const isSourceIdDisabled = () => {
        return selectedFileFromEmail?.length > 0 || selectedFileFromMail || files?.length > 0;
    }

    const deleteSelectedFile = () => {
        setSelectedFileFromMail(null); 
        setSourceIdStatus(''); 
        setViolation({...violation, newViolationFileToUpload: null, newRenamedViolationFileToUpload: null});
    }

	return (
        <>
		<Modal open={open}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
                    overflowX: 'hidden'
				}}
			>
				<div style={{background: "#EFF4FC", display: 'flex', justifyContent: 'space-between'}}>
					<div className="modal-title-container">
						<span className="text-3E3E3E-20px bold">{`${violation.objectId ? 'Update' : 'Add'} Violations`}</span>
						<span className="text-5B5B5B-14px  normal">
                            Please provide necessary information to add new violations.
						</span>
					</div>
                    <div style={{padding: '24px', cursor: 'pointer'}} onClick={onClickStageModalClose}>
                        <CloseIcon />
                    </div>
                </div>

                <Card
                    variant="outlined"
                    className="violation-card-container"
                >
                    <Stack direction={"row"}>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginRight: "17px",
                                marginTop: "17px",
                            }}
                            label={"Violation"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            value={violation.violation || ""}
                            name="violation"
                            required
                            error={ error &&!violation.violation}
                            onChange={handleChange}
                        />
                        <TextField
                            style={{
                                padding: "10px 0px",
                                width: "250px",
                                marginTop: "17px",
                            }}
                            label={"Violation Fee"}
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="standard"
                            type='number'
                            value={violation.violationFee || ""}
                            name="violationFee"
                            required
                            error={ error && !violation.violationFee}
                            onChange={handleChange}
                            onWheel={e => Wheel(e)}
                        />
                    </Stack>
                    <Stack direction={"row"}>
                        <CustomDateField 
                            label="Violation Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                marginRight: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(violation.violationDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "violationDate", value: value } })
                            }}
                        />
                        <CustomDateField 
                            label="Due Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(violation.dueDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "dueDate", value: value } })
                            }}
                        />
                    </Stack>
                    <Stack direction={"row"}>
                        <CustomDateField 
                             label="Hearing Date"
                            error={false}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                marginRight: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(violation.hearingDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "hearingDate", value: value } })
                            }}
                        />
                        <CustomDateField 
                            label="Notice Date"
                            error={ error && !violation.noticeDate}
                            variant="standard"
                            style={{
                                marginTop: "17px",
                                width: "250px",
                                padding: "10px 0px"
                            }}
                            value={dayjs(violation.noticeDate || null)}
                            handleChange={(value: any) =>{
                                handleChange({ date: { key: "noticeDate", value: value } })
                            }}
                        />
                    </Stack>
                    <Stack direction={"row"}>
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{  width: "250px", marginRight: "17px", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            size="small"
                            value={violation.violationCategory ? violation.violationCategory : ''}
                            options={Object.keys(config.violationCategory)}
                            onChange={(e, v) => {
                                handleDropdown(v, "violationCategory")
                            }}
                            renderInput={(params: any) => <TextField variant="standard" error={ error && !violation.violationCategory} style={{height:"100%", marginTop: "17px"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label={<Typography style={{fontSize:"14px"}}>Violation Category</Typography>} />}
                        />
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{ width: "250px", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            value={violation.violationSubcategory ? violation.violationSubcategory : ''}
                            options={violation?.violationCategory ? Object.values(config.violationCategory[violation?.violationCategory]) : []}
                            onChange={(e, v) => {
                                handleDropdown(v, "violationSubcategory")
                            }}
                            renderInput={(params: any) => <TextField variant="standard" error={ error && !violation.violationSubcategory} style={{height:"100%", marginTop: "17px"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label={<Typography style={{fontSize:"14px"}}>Violation Sub-category</Typography>} />}
                        />
                    </Stack>
                    <Stack direction={"row"} style={{marginTop: '17px'}}>
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{  width: "250px", marginRight: "17px", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            value={violation.stage ? violation.stage : ''}
                            options={config.violationStageNotices}
                            onChange={(e, v) => {
                                handleDropdown(v, "stage")
                            }}
                            renderInput={(params: any) => <TextField variant="standard" error={ error && !violation.stage} style={{height:"100%", marginTop: "17px"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label={<Typography style={{fontSize:"14px"}}>Stage</Typography>} />}
                        />
                        <Autocomplete
                            ListboxProps={{ style: { maxHeight: "200px"} }}
                            style={{  width: "250px", marginTop: "17px", height:"62px", boxSizing:"border-box"}}
                            disablePortal
                            value={violation.fineFrequency ? violation.fineFrequency : ''}
                            options={config.fineFrequency}
                            onChange={(e, v) => {
                                handleDropdown(v, "fineFrequency")
                            }}
                            renderInput={(params: any) => <TextField variant="standard" style={{height:"100%"}} {...{...params, InputProps:{...params.InputProps, style:{height:"100%"}}}} label={<Typography style={{fontSize:"14px"}}>Fine Frequency</Typography>} />}
                        />
                    </Stack>
                    
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Hearing Details</span>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                marginTop: "17px",
                            }}
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="outlined"
                            value={violation.hearingDetails || ""}
                            name="hearingDetails"
                            onChange={handleChange}
                        />
                    </Stack>
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Resolve Instructions</span>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                marginTop: "17px",
                            }}
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="outlined"
                            value={violation.resolveInstructions || ""}
                            name="resolveInstructions"
                            onChange={handleChange}
                        />
                    </Stack>
                    {/* Source id verification component */}
                    <SourceIdVerificationComp 
                        files={files}
                        error={error}
                        loading={loading}
                        violation={violation}
                        handleChange={handleChange}
                        sourceIdStatus={sourceIdStatus}
                        deleteModalOpen={deleteModalOpen}
                        isVerifyDisabled={isVerifyDisabled}
                        emailFilesOptions={emailFilesOptions}
                        getFilesBySourceId={getFilesBySourceId}
                        deleteSelectedFile={deleteSelectedFile}
                        isSourceIdDisabled={isSourceIdDisabled}
                        selectedFileFromMail={selectedFileFromMail}
                        selectedFileFromEmail={selectedFileFromEmail}
                        isSourceIdTypeDisabled={isSourceIdTypeDisabled}
                        handleSelectFileFromEmail={handleSelectFileFromEmail}
                    />

                    <FormControl  style={{ width: "90%", margin:'14px'}} component="fieldset" variant="standard" >
                        <FormGroup style={{ display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                        </FormGroup>
                    </FormControl>
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Remarks</span>
                        <TextField
                            style={{
                                padding: "10px 0px",
                                marginTop: "17px",
                            }}
                            multiline
                            InputLabelProps={{ style: { fontSize: "14px" } }}
                            variant="outlined"
                            value={violation.remarks || ""}
                            name="remarks"
                            onChange={handleChange}
                        />
                    </Stack>
                    {(violation?.violationType || !violation?.objectId) ? (<Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Violation Type</span>
                        <RadioGroup
                            name="violationType"
                            value={violation.violationType || "HOA Violation"}
                            onChange={handleChange}
                            row
                            style={{
                                padding: "10px 0px",
                                marginTop: "14px",
                            }}
                        >
                            <FormControlLabel
                                value="HOA Violation"
                                control={<Radio />}
                                label="HOA Violation"
                            />
                            <FormControlLabel
                                value="City Violation"
                                control={<Radio />}
                                label="City Violation"
                            />
                        </RadioGroup>
                    </Stack> ): (
                    <Stack marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Violation Type</span>
                        <RadioGroup
                            name="violationType"
                            value={violation.violationType || ""}
                            onChange={handleChange}
                            row
                            style={{
                                padding: "10px 0px",
                                marginTop: "14px",
                            }}
                        >
                            <FormControlLabel
                                value="HOA Violation"
                                control={<Radio />}
                                label="HOA Violation"
                            />
                            <FormControlLabel
                                value="City Violation"
                                control={<Radio />}
                                label="City Violation"
                            />
                        </RadioGroup>
                    </Stack> 
                    )}
                    <Stack direction={`column`} marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">HOA Information</span>
                        {
                            violation?.hoaInfo && violation?.hoaInfo.map((item: any, index: number) => (
                                <Stack direction={`row`}>
                                <TextField
                                    style={{
                                        padding: "10px 0px",
                                        width: "250px",
                                        marginRight: "17px",
                                        marginTop: "17px",
                                    }}
                                    label={"HOA ID"}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    variant="standard"
                                    value={item.hoaId || ""}
                                    error={ error && !item.hoaId}
                                    name="hoaId"
                                    onChange={(e) => handleHoaInfo(index, 'hoaId', e.target.value)}
                                />
                                <TextField
                                    style={{
                                        padding: "10px 0px",
                                        width: "250px",
                                        marginTop: "17px",
                                    }}
                                    label={"HOA Name"}
                                    InputLabelProps={{ style: { fontSize: "14px" } }}
                                    variant="standard"
                                    value={item.hoaName || ""}
                                    error={ error && !item.hoaName}
                                    name="hoaName"
                                    onChange={(e) => handleHoaInfo(index, 'hoaName', e.target.value)}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end" style={{paddingBottom: '14px'}}>
                                                <IconButton>
                                                    {index === 0 ? <AddCircleOutline onClick={addNewHoaInfo} /> : <RemoveCircleOutline onClick={()=>removeHoaInfo(index)} />}
                                                </IconButton>
                                            </InputAdornment>
                                    )}}
                                />
                                </Stack>
                            ))
                        }
                    </Stack>
                    {(violation.violationType === 'City Violation' || !violation?.violationType) && <Stack direction={`column`} marginTop={"17px"}>
                        <span className="text-5B5B5B-14px">Other Entity Information</span>
                        <Stack direction={`row`}>
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginRight: "17px",
                                    marginTop: "10px",
                                }}
                                label={"Name"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={violation.otherEntityInformation?.name || ""}
                                name="name"
                                error={ error && !violation?.otherEntityInformation?.name}
                                onChange={handleOtherEntityChange}
                            />
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginTop: "10px",
                                }}
                                label={"Email"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={violation.otherEntityInformation?.email || ""}
                                name="email"
                                error={ error && !violation?.otherEntityInformation?.email}
                                onChange={handleOtherEntityChange}
                            />
                        </Stack>
                        <Stack direction={`row`}>
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginRight: "17px",
                                    marginTop: "10px",
                                }}
                                label={"Phone"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={violation.otherEntityInformation?.phone || ""}
                                name="phone"
                                error={ error && !violation?.otherEntityInformation?.phone}
                                onChange={handleOtherEntityChange}
                            />
                            <TextField
                                style={{
                                    padding: "10px 0px",
                                    width: "250px",
                                    marginTop: "10px",
                                }}
                                label={"Address"}
                                InputLabelProps={{ style: { fontSize: "14px" } }}
                                variant="standard"
                                value={violation.otherEntityInformation?.address || ""}
                                name="address"
                                error={ error && !violation?.otherEntityInformation?.address}
                                onChange={handleOtherEntityChange}
                            />
                        </Stack>
                    </Stack>}
                    <Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={() => onClickStageModalClose()} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={() => saveClickBtnClicked()} variant="contained">
                            Save
                        </Button>
					</Stack>
                </Card>
			</Container>
		</Modal>
        <DeleteModal open={isOpen} onClose={handleDeleteModalClose} handleDelete={documentDelete}/>
        <SavingConfirmationModal open={isSavingConfirmationModalOpen} continueBtnClicked={continueBtnClicked}/>
        </>
	);
};

export default ReportedViolationModal;

const SavingConfirmationModal = ({ open, continueBtnClicked }: any) => {
    return (
        <Modal open={open}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to save?</h2>
							<p style={{color: '#787878'}}>Possible duplicate violation found in this property</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={continueBtnClicked} variant="contained">
                            Continue
                        </Button>
					</Stack>
				</div>
			</Container>
		</Modal>
    )
}

const DeleteModal = ({open, onClose, handleDelete}: any) => {
	return (
		<Modal open={open} onClose={onClose}>
			<Container
				style={{
					background: "white",
					position: "absolute",
					top: "50%",
					left: "50%",
					transform: "translate(-50%, -50%)",
					width: "548px",
					maxHeight: "645px",
					overflow: "auto",
					borderRadius: "8px 8px 0px 0px",
					padding: "0px",
				}}
			>
				<div className="modal-wrapper-doc">
					<Stack 
						style={{ 
							alignItems: "center",
							padding: '12px 24px',
							gap: '12px',	
						}}
						direction={"row"}
						spacing={1}
						justifyContent="flex-between">
						<DeleteForeverIcon 
							style={{color: '#F44336', fontSize: '58px', border: "1px solid #EF5350", borderRadius: "50%", padding: '10px'}}/>
						<div>
							<h2 style={{color: '#3E3E3E'}}>Are you sure you want to delete?</h2>
							<p style={{color: '#787878'}}>This item will be deleted forever</p>
						</div>
					</Stack>

					<Stack
						style={{ marginTop: "24px" }}
						direction={"row"}
						spacing={1}
						justifyContent="flex-end"
					>
                        <Button onClick={() => onClose()} variant="outlined">
                            Cancel
                        </Button>
                        <Button onClick={handleDelete} variant="contained">
                            Delete
                        </Button>
					</Stack>
				</div>
			</Container>
		</Modal>
	)
}